<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <!-- samo zaradi spacinga za md in večje -->
      <div class="pt-md-5 animated fadeIn">
        <v-layout row wrap justify-center>
          <v-container
            fluid
            :class="
              ($store.state.storeAuth.userProfile.isAdmin ||
                $store.state.storeAuth.userProfile.isSuperAdmin ||
                $store.state.storeAuth.userProfile.isSuperStoreAdmin) &&
              $store.state.storeClient.client.basicSettings.name ==
                $store.state.storeAuth.userProfile.client
                ? 'py-0 pb-2 mb-2'
                : 'py-0'
            "
            :style="
              ($store.state.storeAuth.userProfile.isAdmin ||
                $store.state.storeAuth.userProfile.isSuperAdmin ||
                $store.state.storeAuth.userProfile.isSuperStoreAdmin) &&
              $store.state.storeClient.client.basicSettings.name ==
                $store.state.storeAuth.userProfile.client
                ? 'border-bottom: 1px dashed gray;'
                : ''
            "
          >
            <v-layout row>
              <home-menu-admin></home-menu-admin>
              <home-menu-admin-stats></home-menu-admin-stats>
            </v-layout>
          </v-container>
          <home-menu-active-promotions
            v-if="anyActivePromotions"
          ></home-menu-active-promotions>
          <v-container fluid class="py-0">
            <v-layout row>
              <home-menu-module-photo-order></home-menu-module-photo-order>
              <home-menu-module-photo-gift-item
                v-for="item in $store.state.storeGiftSuperCategory
                  .giftSuperCategory"
                :key="item.id"
                :item="item"
              ></home-menu-module-photo-gift-item>
              <home-menu-user-settings></home-menu-user-settings>
            </v-layout>
          </v-container>
          <home-menu-cart-info></home-menu-cart-info>

          <!-- APP UPDATE CONFIRM DIALOG -->
          <dialog-basic-yes-no
            :active="dialogUpdate"
            @clickYes="appUpdate"
            @clickNo="dialogUpdate = false"
            icon="mdi-cellphone-arrow-down"
            :title="$t('appUpdateDialogTitle')"
            >{{ $t("appUpdateDialogBody") }}</dialog-basic-yes-no
          >

          <!-- APP ALLOW COOKIES; POLICY, GDPR CONFIRM DIALOG -->
          <dialog-confirmations
            :active="showAllowScreen"
            @clickYes="saveConsent"
            @clickNo="SignOut"
            :body="$t('appUpdateDialogBody')"
          ></dialog-confirmations>
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import AppNavigation from "@/views/AppNavigation";
import HomeMenuAdmin from "@/views/homeMenu/HomeMenuAdmin";
import HomeMenuAdminStats from "@/views/homeMenu/HomeMenuAdminStats";
import HomeMenuActivePromotions from "@/views/homeMenu/HomeMenuActivePromotions";
import HomeMenuCartInfo from "@/views/homeMenu/HomeMenuCartInfo";
import HomeMenuModulePhotoOrder from "@/views/homeMenu/HomeMenuModulePhotoOrder";
import HomeMenuModulePhotoGiftItem from "@/views/homeMenu/HomeMenuModulePhotoGiftItem";
import HomeMenuUserSettings from "@/views/homeMenu/HomeMenuUserSettings";
import DialogBasicYesNo from "@/components/DialogBasicYesNo";
import DialogConfirmations from "../components/DialogConfirmations.vue";
import { firebaseApp } from "@/firebase";
//import moment from "moment";

export default {
  name: "home",
  components: {
    AppNavigation,
    HomeMenuAdmin,
    HomeMenuAdminStats,
    HomeMenuActivePromotions,
    HomeMenuCartInfo,
    HomeMenuModulePhotoOrder,
    HomeMenuModulePhotoGiftItem,
    HomeMenuUserSettings,
    DialogBasicYesNo,
    DialogConfirmations,
  },
  data() {
    return {
      dialogUpdate: false,
      showAllowScreen: false,
    };
  },
  computed: {
    anyActivePromotions() {
      // vrnemo vse aktivne promo kode, vendar za izpis skrite izpustimo
      return this.$store.state.storePromoCode.activePromoCodes.filter(
        (x) => !x.hidden
      ).length > 0
        ? true
        : false;
    },
  },
  methods: {
    appUpdate() {
      let id =
        "myphotopal-precache-v2-https://" +
        this.$store.state.storeClient.client.basicSettings.name +
        ".myphotopal.shop/";
      caches.open(id).then((cache) =>
        cache.keys().then((keys) => {
          for (let key of keys) {
            //console.log(key + " <== deleted");
            cache.delete(key);
          }
        })
      );
      location.reload(true);
    },
    saveConsent() {
      this.showAllowScreen = false;
      this.$store.dispatch("updateConfirmations", {
        email: this.$store.state.storeAuth.user.email,
        allowCookies:
          this.$store.state.storeClient.client.rulesAndSecurityInfo
            .showCookiesInfo ||
          this.$store.state.storeAuth.userProfile.allowCookies
            ? true
            : false,
        allowRules:
          this.$store.state.storeClient.client.rulesAndSecurityInfo
            .showRulesInfo || this.$store.state.storeAuth.userProfile.allowRules
            ? true
            : false,
        allowPrivacy:
          this.$store.state.storeClient.client.rulesAndSecurityInfo
            .showPrivacyInfo ||
          this.$store.state.storeAuth.userProfile.allowPrivacy
            ? true
            : false,
      });
    },
    async SignOut() {
      await firebaseApp.signOut();
      this.$router.replace("/login");
    },
  },
  async created() {
    // update dialog zaenkrat skrijemo, ker ne deluje čist ok na glavni strani
    /*  await this.$store.dispatch("getLatestVersion");
    if (
      this.$store.getters.appVersion !==
      this.$store.state.storeVersion.latestVersion.latest
    )
      this.dialogUpdate = true;*/
    this.$store.dispatch("getBrowser");
    this.$store.dispatch("getMemory");
    this.$store.dispatch("getOS");
  },
  async mounted() {
    // preverimo, ali je potrebno prikazati okno za privoljenja
    if (!this.$store.state.storeAuth.userProfile.email) {
      await this.$store
        .dispatch("fetchUserProfile", this.$store.state.storeAuth)
        .then(() => {
          if (
            (this.$store.state.storeClient.client.rulesAndSecurityInfo
              .showCookiesInfo &&
              (!this.$store.state.storeAuth.userProfile.allowCookies ||
                this.$store.state.storeAuth.userProfile.allowCookies ==
                  undefined)) ||
            (this.$store.state.storeClient.client.rulesAndSecurityInfo
              .showRulesInfo &&
              (!this.$store.state.storeAuth.userProfile.allowRules ||
                this.$store.state.storeAuth.userProfile.allowRules ==
                  undefined)) ||
            (this.$store.state.storeClient.client.rulesAndSecurityInfo
              .showPrivacyInfo &&
              (!this.$store.state.storeAuth.userProfile.allowPrivacy ||
                this.$store.state.storeAuth.userProfile.allowPrivacy ==
                  undefined))
          ) {
            this.showAllowScreen = true;
          }
        });
    }
  },
};
</script>
